module.exports = __webpack_public_path__ + "apple_macbook15_icon.svg?c61528646cd76bcebf3b6f5b58ed5307";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/apple_macbook15_icon.svg
// module id = 217
// module chunks = 0